import type { IDeactivateProfileResponse, IGenerateTokenResponse } from "../typings";
import { useTransport } from "../composables/useTransport";
import useDirectFetch from "../composables/useDirectFetch";
import { urls } from "./config";

const getLoginParams = (aud: string, magnitIDCode: string, options = {}) => ({
  gateway: "magnit-id" as const,
  method: "POST" as const,
  body: {
    aud,
    magnitIDCode,
  },
  ...options,
});
export const requestLogin = (aud: string, magnitIDCode: string, options = {}) => {
  return useTransport<IGenerateTokenResponse>(urls.auth.login, getLoginParams(aud, magnitIDCode, options));
};
export const fetchLogin = (aud: string, magnitIDCode: string, options = {}) => {
  return useDirectFetch<IGenerateTokenResponse>(urls.auth.login, getLoginParams(aud, magnitIDCode, options));
};

const getDeactivateParams = (options = {}) => ({
  gateway: "magnit-id" as const,
  method: "POST" as const,
  permissions: { jwt: true },
  ...options,
});

export const requestDeactivate = (options = {}) => {
  return useTransport<IDeactivateProfileResponse>(urls.user.deactivate, getDeactivateParams(options));
};
export const fetchDeactivate = (options = {}) => {
  return useDirectFetch<IDeactivateProfileResponse>(urls.user.deactivate, getDeactivateParams(options));
};

const getRefreshOptions = (aud: string, refreshToken: string, options = {}) => ({
  gateway: "magnit-id" as const,
  method: "POST" as const,
  body: {
    aud,
    refreshToken,
  },
  ...options,
});

export const requestRefreshTokens = (aud: string, refreshToken: string, options = {}) => {
  return useTransport<IGenerateTokenResponse>(urls.auth.refresh, getRefreshOptions(aud, refreshToken, options));
};
export const fetchRefreshTokens = (aud: string, refreshToken: string, options = {}) => {
  return useDirectFetch<IGenerateTokenResponse>(urls.auth.refresh, getRefreshOptions(aud, refreshToken, options));
};

const getExchangeExternalOptions = (token: string, options = {}) => ({
  gateway: "magnit-id" as const,
  method: "POST" as const,
  body: {
    token,
    aud: "loyalty-web",
  },
  permissions: { jwt: true },
  ...options,
});

export const requestExchangeExternalToken = (token: string, options = {}) =>
  useTransport<IGenerateTokenResponse>(
    urls.auth.exchangeExternalToken,
    getExchangeExternalOptions(token, options),
  );

export const fetchExchangeExternalToken = (token: string, options = {}) =>
  useDirectFetch<IGenerateTokenResponse>(
    urls.auth.exchangeExternalToken,
    getExchangeExternalOptions(token, options),
  );
